import styled from "styled-components"
import { colors } from "../../styles/GlobalStyles"

export const Wrapper = styled.div`
	display: grid !important;
	grid-gap: 20px 20px;
	margin: auto;
	grid-template-columns: 1fr;
	@media screen and (min-width: 550px) {
		grid-template-columns: 1fr 1fr;
		grid-gap: 40px 20px;
	}
	@media screen and (min-width: 1050px) {
		grid-template-columns: 1fr 1fr 1fr;
		grid-gap: 40px;
	}
`

export const FeedbackWrapper = styled.div`
	background: ${colors.white};
	width: 90%;
	max-width: 100%;
	overflow-wrap: anywhere;
	margin: 0px auto auto auto;
`
